<template>
  <div>
    <!-- 顶部banner -->
    <banner :image="require(`@/assets/solution/banner5.jpg`)"  :fontText="fontText" />
    <!-- 一 -->
    <div class="floor-live" style="height: 100%;padding-bottom: 50px">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            电商直播的未来与新机遇
          </div>
        </div>
        <div class="retailForEach" data-aos="fade-up">
          <div class="live-opportunity">
            <div class="live-container-title">
              现状
            </div>
            <div class="live-container-cont">
              2021年6月-2023年6月<br/>直播电商用户规模及其占网络购物用户规模的比例
            </div>
            <img src="@/assets/solution/liveNum1.png" alt="" style=" width: 496px; height: 339px;">
          </div>
          <div class="live-Challenge">
            <div class="live-container-title">
              新的机遇
            </div>
            <div class="live-container-cont" style="text-align: center;">
              2023年6月直播电商用户规模达到5.3亿人，占网络购物用户规模的比例达到59.5%，<br/>直播电商已成为网络购物用户购买商品的重要途径之一。<br/>未来伴随直播电商用户规模的持续增长，直播电商行业流量池将进一步扩容。
            </div>
          </div>
        </div>
        <div style="margin-bottom:50px" data-aos="fade-up">
          <div class="title">
            打造多种直播模式，抓住直播红利
          </div>
        </div>
        <div data-aos="fade-up">
          <div class="live-flex">
            <div class="itemOne">
              <div class="live-item-title" style="margin-top:38px">
                AI直播
              </div>
              <div class="live-item-content" style="text-align: center;">
                快速搭建3D虚拟场景，设计精彩特效与场景融合，接入数字人驱动，完美演绎虚拟现实直播
              </div>
            </div>
            <div class="itemTwo">
              <div class="live-item-title" style="margin-top:38px">
                全景直播
              </div>
              <div class="live-item-content" style="text-align: center;padding: 0 20px;">
                超高清8K分辨率，超强防抖功能，视频光流拼接，真实还原线下场景，720°完美沉浸式体验
              </div>
            </div>
          </div>
          <div class="live-flex">
            <div class="itemThr">
              <div class="live-item-title" style="margin-top:38px">
                视频直播
              </div>
              <div class="live-item-content" style="text-align: center;padding: 0 20px;">
                企业级直播互动平台，提供多场景直播解决方案，百万级并发流畅体验，满足各类直播需求
              </div>
            </div>
            <div class="itemFour">
              <div class="live-item-title" style="margin-top:38px">
                照片直播
              </div>
              <div class="live-item-content" style="text-align: center;padding: 0 20px;">
                品质拍摄，即拍即传，即拍即享，活动精彩画面实时展现。线上分类存储，资源更好管理
              </div>
            </div>
            <div class="itemFive">
              <div class="live-item-title" style="margin-top:38px">
                图文直播
              </div>
              <div class="live-item-content" style="text-align: center;padding: 0 20px;">
                现场拍摄上传，以时间轴记录活动始终增强现场直观感受，适用于即时比赛或新闻现场报道
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <!-- 二 -->
    <div class="floor-live-bg floor-tab-height750">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            功能丰富，解锁直播新玩法
          </div>
        </div>
        <div class="retailForEach" style="flex-wrap: wrap;" data-aos="fade-up">
          <div v-for="(item,index) in liveTwoList" :key="index" class="live-item-three">
            <img :src="item.icon" alt="">
            <div class="live-item-three-title">{{item.title}}</div>
            <div class="live-item-three-content" v-html="item.content"></div>
          </div>
        </div>
      </div>

    </div>
    <!-- 三 -->
    <div class="floor-live floorColor floor-tab-height950">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            直播产品架构
          </div>
        </div>
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/liveOne.png" alt="" />
        </div>
      </div>

    </div>
    <!-- 四 -->
    <div class="floor-live ">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            连通各大平台，一键直播全网卖货
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            多平台蓄水流量，链接数十亿流量资源，更多流量等于更多销量
          </div>
        </div>
        <div data-aos="fade-up">
          <div class="live-content">
            <div class="live-content-font">通过直播电商，帮你打通微信、小红书、抖音等各大直播平台，轻松连接10亿流量。</div>
            <div class="live-content-font" style="margin-left:190px">通过直播效果的不断优化，反复触达客户，完成从“流量”到“销量”的完美转化。</div>
          </div>
          <div class="financial-container-two">
            <img src="@/assets/solution/liveNum7.png" style="width:620px;height:444px;" alt="" />
            <div class="financial-content-two">
              <div class="financial-content-item-two">
                <img src="@/assets/solution/correctIcon.png" alt="" />
                <div>
                  <div class="financial-content-title">直播区</div>
                  <div class="financial-item-content">平台的商家主播可以发起直播，与观众互动聊天，直播的同时还可以关联商品的购买链接</div>
                </div>
              </div>
              <div class="financial-content-item-two">
                <img src="@/assets/solution/correctIcon.png" alt="" />
                <div>
                  <div class="financial-content-title">点播区</div>
                  <div class="financial-item-content">商家根据不同的商品分类，上传介绍视频，视频可作为长期存储便于用户观看</div>
                </div>
              </div>
              <div class="financial-content-item-two">
                <img src="@/assets/solution/correctIcon.png" alt="" />
                <div>
                  <div class="financial-content-title">小视频</div>
                  <div class="financial-item-content">主播可以上传类似抖音的10秒小视频，用精简的介绍方式快速勾起用户的消费兴趣</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <!-- 五 -->
    <div class="floor-live floorColor floor-tab-height700">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            无缝连接商家、厂家、主播，流量高效变现
          </div>
        </div>
        <div class="flex-container" data-aos="fade-up">
          <div  class="flex-container-item" style="width: 390px;height: 430px;">
            <div class="flex-container-title" style="margin-top: 38px;">
              我是商家，我想卖货
            </div>
            <div class="flex-container-cont" style="display: block;width: 266px;margin: auto;">
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">帮你对接 千万级网红主播</div>
              </div>
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">一键上架 自动分佣</div>
              </div>
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">指导直播间搭建 快速成单</div>
              </div>
            </div>
            <img src="@/assets/solution/liveNum11.png" style="width: 330px;height: 200px;" alt="" />
          </div>
          <div  class="flex-container-item" style="width: 390px;height: 430px;">
            <div class="flex-container-title" style="margin-top: 38px;">
              我是主播，我想带货
            </div>
            <div class="flex-container-cont" style="display: block;width: 266px;margin: auto;">
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">帮你对接 品牌商家</div>
              </div>
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">品质高，口碑好全网底价</div>
              </div>
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">趣味互动：涨人气、涨粉丝</div>
              </div>
            </div>
            <img src="@/assets/solution/liveNum12.png" style="width: 330px;height: 200px;" alt="" />
          </div>
          <div  class="flex-container-item" style="width: 390px;height: 430px;">
            <div class="flex-container-title" style="margin-top: 38px;">
              我有货源，我想供货
            </div>
            <div class="flex-container-cont" style="display: block;width: 266px;margin: auto;">
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">帮你对接 百万商家和网红</div>
              </div>
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">全网分销 自动结算</div>
              </div>
              <div class="flex-container-cont-item-live">
                <img src="@/assets/home/case_check.svg" alt="">
                <div class="flex-container-cont-font">足不出户 躺着赚钱</div>
              </div>
            </div>
            <img src="@/assets/solution/liveNum13.png" style="width: 330px;height: 200px;" alt="" />
          </div>
        </div>
      </div>

    </div>
    <!-- 六 -->
    <div class="floor-live" style="height: 650px">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            AI营销策划，让你创意不断
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            融合多年行业活动经验，AIGC帮你生成促销文案、剪辑视频，同时投放到小红书、微博等平台
          </div>
        </div>
        <div class="financial-container-two" data-aos="fade-up">
          <div class="financial-content-two" style="margin-top: 10px;width:465px">
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">脚本文案</div>
                <div class="financial-item-content">输入关键词、场景等信息，一键生成多行业爆款脚本文案，写脚本不愁没灵感</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">智能剪辑</div>
                <div class="financial-item-content">仅需少量素材片段，快速批量混剪大量视频，可自定义风格、场景，助力企业宣传不重复</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">多账号营销批量发布</div>
                <div class="financial-item-content">多平台一键发布，多账号批量管理，一键批量分发短视频至小红书、微博、抖音、快手等平台，获取更多曝光，实现获客营销新增长</div>
              </div>
            </div>
          </div>
          <img src="@/assets/solution/liveNum8.png"  style="width:677px;height:412px;" alt="" />
        </div>
      </div>

    </div>
    <!-- 七 -->
    <div class="floor-live floor-tab-height840">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            AI虚拟直播，助你永远在线
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            全新直播方式，虚拟形象替代真人出镜，打造不一样的直播体验，支持表情随动、手势识别触发特效等多种玩法
          </div>
        </div>
        <div class="financial-container-two" data-aos="fade-up">
          <img src="@/assets/solution/liveNum9.png" style="width:647px;height:480px;" alt="" />
          <div class="financial-content-two" style="width:495px">
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">个性虚拟形象</div>
                <div class="financial-item-content">塑造全新的个性化虚拟形象，自由表达内心情感</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">实时表情随动</div>
                <div class="financial-item-content">精准捕获面部表情，基于52个基础表情维度，实时还原渲染表情随动效果，生动讲解选品策略，商品卖点</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">降低开播成本</div>
                <div class="financial-item-content">上千个直播间在云端同时播，进一步降低开播成本30%</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">全天候直播</div>
                <div class="financial-item-content">做到真人主播和数字人主播切换，24小时无人值守</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from '../../components/Footer'
import banner from './components/banner'
import floorTwo from './components/floor2'

export default {
  name: "live",
  components: {
    floorTwo,
    Footer,
    banner
  },
  data() {
    return {
      fontText: {
        title: '直播（AI）解决方案',
        txtMiddle: [
          '电商+直播+AI 一体化解决方案',
          '把握直播流量红利，助力商家将流量快速变现',
        ]
      },
      liveList: [
        {
          iconArr: [
            {
              icon: require("@/assets/solution/shopIcon1.png"),
              text: '拼多多'
            },
            {
              icon: require("@/assets/solution/shopIcon2.png"),
              text: '苏宁拼购'
            },
            {
              icon: require("@/assets/solution/shopIcon3.png"),
              text: '京东拼购'
            },
          ],
          title: '拼团砍价模式',
          content: '拼多多崛起后，带动了主流电商平台也开启了拼团砍价模式，通过微信的社交优势，开启多人拼团，结合全民砍价，“砍一刀”快速传播分享'
        },
        {
          iconArr: [
            {
              icon: require("@/assets/solution/shopIcon4.png"),
              text: '云集'
            },
            {
              icon: require("@/assets/solution/shopIcon5.png"),
              text: '未来集市'
            },
            {
              icon: require("@/assets/solution/shopIcon6.png"),
              text: '顺联动力'
            },
          ],
          title: '会员制分销模式',
          content: '云集模式的成功，将分销与会员的社交电商模式带来了一个全新的玩法，用户通过开通会员获得分享权益，推荐更多会员享受提成'
        },
        {
          iconArr: [
            {
              icon: require("@/assets/solution/shopIcon7.png"),
              text: '小红书'
            },
            {
              icon: require("@/assets/solution/shopIcon8.png"),
              text: '蘑菇街'
            },
            {
              icon: require("@/assets/solution/shopIcon9.png"),
              text: '值得买'
            },
          ],
          title: '内容电商模式',
          content: '通过长文章内容模式，引入商品介绍分享使用心得，同时关联商品购买地址带动商品销售'
        },
      ],
      liveTwoList: [
        {
          icon: require("@/assets/solution/liveIcon11.png"),
          title: '直播导购',
          content: '<span>通过在线互动、实物演示、实时答</br>疑，增强顾客信任，加速购买决策</span>'
        },
        {
          icon: require("@/assets/solution/liveIcon12.png"),
          title: '短视频导购',
          content: '<span>对接主流短视频平台，用短视频推荐</br>商品，引导观众边看边买</span>'
        },
        {
          icon: require("@/assets/solution/liveIcon13.png"),
          title: '数字人直播',
          content: '<span>提供了百余个精选数字人形象，用户</br>可以根据自己的需求选择适合的形象</br>进行语音合成和视频制作</span>'
        },
        {
          icon: require("@/assets/solution/liveIcon4.png"),
          title: '直播互动',
          content: '<span>通过人工智能技术，实现与观众的互</br>动，如自动回复观众的问题、根据观众的需求调整直播内容</span>'
        },
        {
          icon: require("@/assets/solution/liveIcon5.png"),
          title: '文案智能生成',
          content: '<span>输入关键词、场景等信息，一键生成</br>多行业爆款脚本文案，不愁没灵感</span>'
        },
        {
          icon: require("@/assets/solution/liveIcon6.png"),
          title: '自动化剪辑',
          content: '<span>上传音频文件，即刻输出直播 / 短</br>视频内容，提供短视频内推广分发矩</br>阵工具</span>'
        },
        {
          icon: require("@/assets/solution/liveIcon7.png"),
          title: '多平台分发',
          content: '<span>支持多平台直播，抖音、快手、淘</br>宝、视频号、B站、 小红书、拼多多</br>等平台内容分发</span>'
        },
        {
          icon: require("@/assets/solution/liveIcon8.png"),
          title: '数据分析',
          content: '<span>引流数据分析、直播概况分析、用户</br>画像分析、互动数据分析</span>'
        },
      ],
      selectIndex: 0,
      tabList: [
        {
          value: 0,
          name: '智能制造'
        },
        {
          value: 1,
          name: '智慧供应链'
        },
        {
          value: 2,
          name: '智慧门店'
        },
      ],
      liveTabList: [
        {
          title: '打造创新社交分销模式',
          content: '融合拼团、分销、信息流等多种前沿社交营销模式，引爆流量，搭建以人为中心的社交电商解决方案',
          image: require("@/assets/solution/shopOne.png"),
        },
        {
          title: '快速搭建分销渠道',
          content: '搭建小程序+公众号+微商城+APP的一体化分销渠道，魔方建站体系，多样化组件任意拖拽，无需美工，快速搭建企业专属分销商城',
          image: require("@/assets/solution/shopTwo.png"),
        },
        {
          image: require("@/assets/solution/shopThr.png"),
          bottomTitle: '<span>制定激励规则</br>用利益和规则聚拢分销合伙人</span>',
          bottomContent: '制定激励规则，激励用户进行消费、分享等行为，通过等级管理、团队激励、推广佣金、消费返利等业务功能即可完成社交分销的起盘环节'
        },
      ],
      liveThrList: [
        {
          title: '经营策略',
          content: '行业市场及目标人群分析，深挖需求痛点，制分销方案',
          image: require("@/assets/solution/shopNum5.png"),
        },
        {
          title: '系统工具',
          content: '提供高效且有用的系统及工具，支持定制以及对接原系统',
          image: require("@/assets/solution/shopNum6.png"),
        },
        {
          title: '客户信息的共享和整合',
          content: '专业运营团队陪跑式服务，随时监督和指导，贡献运营建议',
          image: require("@/assets/solution/shopNum7.png"),
        },
        {
          title: '统一的客户服务体验',
          content: '海量优质广告资源位提供，营销活动精准触达目标客户群',
          image: require("@/assets/solution/shopNum8.png"),
        },
      ],
    };
  },
  methods: {
    // 当鼠标进入元素时触发
    // handleMouseEnter(index) {
    //   // console.log('鼠标进入了元素' + index);
    //   this.industrySelecedIndex = index;
    // },
    // 当鼠标离开元素时触发
    // handleMouseLeave(index) {
    //   // console.log('鼠标离开了元素');
    // },
  },
};
</script>

<style lang="less" scoped>
.floor-live {
  width: 100%;
  height: 920px;
  background: #fff;
}
.imgHeight470 img{
  height: 470px;
}
.financial-container-two{
  width: 1200px;
  margin: auto;
  margin-top: 45px;
  display: flex;
  justify-content: space-between;
}
.financial-container-two img{
  width: 600px;
  /* height: 480px; */
}

.financial-content-two{
  width: 520px;
  margin-top: 38px;
}
.financial-content-item-two{
  text-align: left;
  display: flex;
  margin-bottom: 10px;
}

.financial-content-title{
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 14px;
}
.financial-item-content{
  color: #595859;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 36px;
}
.imgHeight470 img{
  height: 470px;
}
.financial-content-item-two img{
  width: 22px;
  height: 16px;
  margin-top: 8px;
  margin-right: 10px;
}

.live-item{
  width: 380px;
  height: 370px;
  /* margin: auto; */
  background: #F4F5FB;
  border-radius: 6px;
  padding: 48px 40px;
}
.live-item img{
  width: 60px;
  height: 60px;
  /* margin-top: 30px;
  margin-bottom: 18px; */
}
.live-item-title{
  font-size: 18px;
  color: #222222;
  font-weight: bold;
  margin-bottom: 12px;
}
.live-item-content{
  /* padding: 0 50px; */
  color: #595859;
  font-size: 14px;
  line-height: 22px;
}
.live-item-forEach-item{
  width: 90px;height:120px;border-radius:6px;background:#fff;padding:15px 15px 0 15px;margin-top: 40px;
}
.live-item-forEach-font{
  color: #222222;
  font-size: 13px;
  margin-top: 10px;
}
.floorBg{
  background: linear-gradient(180deg, #E3EFFF, #F9FAFF);
}
.floor-live .title{
  font-weight: bold; font-size: 32px; color: #222222;padding-top: 80px;margin-bottom: 14px;
}
.floor-live .retailForEach{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.floor-live-bg .retailForEach{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.live-opportunity{
  width: 585px;
  height: 524px;
  background: linear-gradient(180deg, #FAFCFF, #ECF2FF);
  position: relative;
  padding: 35px;
}
.live-opportunity img{
  width: 510px;
  height: 305px;
  margin: auto;
  margin-top: 25px;
}
.live-opportunity-tips{
  position: absolute;
  left: 37px;
  top: 161px;
  font-size: 16px;
  color: #303133;
  line-height: 20px;
  font-weight: 560;
  text-align: left;
}
.live-container-title{
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 25px;
}
.live-container-cont{
  font-size: 14px;
  line-height: 22px;
  color: #333333;
  margin-top: 30px;
  text-align: left;
}
.live-Challenge{
  width: 585px;
  height: 524px;
  background: url('../../assets/solution/liveBg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  padding: 35px 20px;
}
.live-Challenge-position{
  position: absolute;
  padding: 12px 20px;
  background: #FFFFFF;
  border-radius: 6px;
  font-size: 14px;
  color: #333333;
}
.livePosition1{
  left: 20px;
  top: 180px;
  width: 385px;
  height: 78px;
}
.livePosition1 img{
  width: 100%;
}
.livePosition2{
  right: 20px;
  top: 280px;
  width: 375px;
  height: 78px;
}
.livePosition2 img{
  width: 100%;
}
.livePosition3{
  left: 20px;
  top: 380px;
  width: 310px;
  height: 78px;
}
.livePosition3 img{
  width: 100%;
}
.live-item{
  width: 224px;
  height: 200px;
  margin: auto;
  background: linear-gradient(180deg, #FAFCFF, #ECF2FF);
  border-radius: 6px;
}

.live-item img{
  width: 40px;
  height: 40px;
  margin-top: 30px;
  margin-bottom: 18px;
}
.live-item-title{
  font-size: 18px;
  color: #222222;
  font-weight: bold;
  margin-bottom: 12px;
}
.live-item-content{
  /* padding: 0 50px; */
  color: #595859;
  font-size: 14px;
  line-height: 22px;
}
.floor-live .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-live .industry-container img{
  width: 100%;
}

.floorColor{
  background: #F4F5FB;
}
.floor-live-bg{
  width: 100%;
  height: 950px;
  background: url('../../assets/solution/floorBg3.png') no-repeat center center;
  background-size: 1920px 100%;
  background-color: #0B4FD1;

}
.bg2{
  background: url('../../assets/solution/floorBg3.png') no-repeat;
  background-size: 100% 100%;
  height: 1300px;
}
.live-flex{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.itemOne{
  width: 795px;
  height: 340px;
  background: url('../../assets/solution/liveNum2.png') no-repeat;
  background-size: 100% 100%;
}
.itemTwo{
  width: 390px;
  height: 340px;
  background: url('../../assets/solution/liveNum3.png') no-repeat;
  background-size: 100% 100%;
}
.itemThr{
  width: 390px;
  height: 340px;
  background: url('../../assets/solution/liveNum4.png') no-repeat;
  background-size: 100% 100%;
}
.itemFour{
  width: 390px;
  height: 340px;
  background: url('../../assets/solution/liveNum5.png') no-repeat;
  background-size: 100% 100%;
}
.itemFive{
  width: 390px;
  height: 340px;
  background: url('../../assets/solution/liveNum6.png') no-repeat;
  background-size: 100% 100%;
}
.live-content{
  margin: auto;
  width: 1200px;
  height: 110px;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  margin-top: 40px;
  background: url('../../assets/solution/liveBg2.png') no-repeat;
  background-size: 100% 100%;
}
.live-content-font{
  width: 482px;
  text-align: left;
  font-size: 18px;
  line-height: 32px;
  color: #222222;
  margin-left: 25px;
  margin-top: 22px;
}
.live-item-two{
  width: 590px;
  height: 220px;
  padding-top: 55px;
  padding-left: 30px;
  margin-bottom: 20px;
}
.live-item-three{
  background: #FFFFFF;
  width: 285px;
  height: 210px;
  border-radius: 6px;
  margin-bottom: 30px;
  padding: 28px;
}
.live-item-three img{
  width: 40px;
  height: 40px;
}
.live-item-three-title{
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  margin-top: 18px;
}
.live-item-three-content{
  color: #595859;
  font-size: 14px;
  line-height: 20px;
}
.live-two-title{
  text-align: left;
  color: #FFFFFF;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
}
.live-two-content{
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  width: 280px;
  color: #FFFFFF;
}
.floor-live-bg .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-live-bg .industry-container img{
  width: 100%;
}
.floor-live-bg  .title{
  font-weight: bold; font-size: 32px; color: #FFFFFF;padding-top: 80px;margin-bottom: 14px;
}
.floor-tab-height{
  height: 1000px;
}
.floor-tab-height840{
  height: 840px;
}
.floor-tab-height750{
  height: 750px;
}
.floor-tab-height700{
  height: 700px;
}
.floor-tab-height600{
  height: 600px;
}
.floor-tab-height950{
  height:950px;
}
.floor-tab-height1000{
  height:1000px;
}
.floor-tab-height1500{
  height:1500px;
}
.floor-tab-height1350{
  height:1350px;
}
.imgHeight470 img{
  height: 470px;
}
.live-flex-container{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
}
.live-flex-container-item{
  width: 360px;
  height: 640px;
  background: #FFFFFF;
  border-radius: 6px;
}
.live-flex-container-item img{
  width: 100%;
}
.live-flex-container-title{
  color: #222222;
  font-size: 20px;
  font-weight: bold;
  margin-top: 25px;
}
.flex-container{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
}
.flex-container-item{
  width: 380px;
  height: 390px;
  background: #FFFFFF;
  border-radius: 6px;
}
.flex-container-item img{
  width: 340px;
  height: 170px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.flex-container-title{
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 25px;
}
.flex-container-cont{
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  flex-wrap: wrap;
}
.flex-container-cont-item-live{
  display: flex;
  margin-bottom: 10px;
  width: 200px;
}
.flex-item2{
  width: 100px;
}
.flex-container-cont-item-live img{
  width: 22px;
  height: 16px;
  margin: 0;
}
.flex-container-cont-font{
  margin-left: 6px;
  color: #222222;
  font-size: 14px;
}
</style>
